import React, { useContext, useEffect, useMemo, useState } from 'react'
import { ContextNotification, severitys } from '../../../App';
import { MaterialReactTable, useMaterialReactTable, } from 'material-react-table';
import { Box, Button, Card, CardActionArea, CardContent, Container, Paper, Typography, ThemeProvider, useTheme, Grid, Modal, CircularProgress, IconButton, Tooltip, TextField } from "@mui/material";
import themes from '../../../themes';
import { MdFlight } from "react-icons/md";
import { Controller, useForm } from 'react-hook-form';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import DateObject from "react-date-object";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import moment from 'jalali-moment';
import { useNavigate } from 'react-router-dom';
import RtlProvider from '../../../Components/RtlProvider';
import CustomDateInput from '../../../Components/CustomDateInput';
import brokerGroupApi from '../../../api/brokerGroupApi';
import { useSelector } from 'react-redux';
import customtheme from '../../../themes';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import EnumMapper from '../../../EnumMapper';
import helper from '../../../helper';
import AccessControl from '../../../Components/AccessControl';
import { ContextUserInfo } from "../../../Layout/MainLayout";
import { FaRegFileAlt } from "react-icons/fa";
import FlightDelayCompensation from '../DelayCompensation/FlightDelayCompensation';
import ComputFlightCompensation from '../DelayCompensation/FlightCompersation';
import { BiTimer } from "react-icons/bi";
import { ImFileExcel } from "react-icons/im";
import Excel from 'exceljs';
import { saveAs } from 'file-saver';
import FlightCompensationApi from '../../../api/FlightCompensationApi';
import CustomTitle from '../../../Components/CustomTitle';


const DelayList = () => {


    const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
    const [isLoading, setIsloading] = useState(false);
    const [data, setData] = useState([]);
    const { open, setOpen } = React.useContext(ContextNotification);
    const [isError, setIsError] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    const [flightType, setFlightType] = useState([]);
    const navigate=useNavigate();

    //table state
    const [columnFilters, setColumnFilters] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });
    const theme = useTheme();
    const baseBackgroundColor =
        theme.palette.mode === 'dark'
            ? 'rgba(3, 44, 43, 1)'
            : 'rgba(244, 255, 233, 1)';
    const customization = useSelector((state) => state.customization);

    const schema = yup.object().shape({

    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
        resolver: yupResolver(schema),
    });
    const columns = useMemo(
        () => [


            {
                accessorKey: 'data.flightNo',
                id: 'flightNo',
                header: 'شماره پرواز',
                enableSorting: false,
            },
            {
                accessorKey: 'data.originStationName',
                id: 'originStationName',
                header: 'ایستگاه مبدا',
                enableSorting: false,
            },
            {
                accessorKey: 'data.destinationStationName',
                id: 'destinationStationName',
                header: 'ایستگاه مقصد',
                enableSorting: false,
            },

            {
                accessorKey: 'data.flightDate',
                id: 'flightDate',
                header: 'تاریخ پرواز',
                enableSorting: true,
                Cell: ({ cell, row }) => (
                    row.original.data?.flightDatePersian
                ),

            },
            {
                accessorKey: 'data.flightDateReal',
                id: 'flightDateReal',
                header: 'تاریخ پرواز واقعی',
                enableSorting: true,
                Cell: ({ cell, row }) => (
                    row.original.data?.flightDateRealPersian
                ),

            },
            {
                accessorKey: 'data.flightTime',
                id: 'flightTime',
                header: 'ساعت پرواز ',
                enableSorting: true,


            },
            {
                accessorKey: 'data.flightTimeReal',
                id: 'flightTimeReal',
                header: 'ساعت پرواز واقعی',
                enableSorting: true,


            },
            {
                accessorKey: 'data.delayText',
                id: 'delayText',
                header: 'میزان تاخیر',
                enableSorting: false,

            }


        ],
        [],
    );
    const ResetForm = () => {
        setSelectedFlightId(null);
    }
    // DelayCompensation 
    const [selectedFlightId, setSelectedFlightId] = useState(null);
    const GotoCompensation=(row)=>{
     setSelectedFlightId(row.id);
     navigate('/dashboard/DelayPanel/EditFlightCompensation/'+row.id);
    }
    //delayReport

    const [showDelayReportModal, setShowDelayReportModal] = useState(false);
    const handleOpenDelayReportModal = (row) => {
        setSelectedFlightId(row.id);
        setShowDelayReportModal(true);
    }
    const handleCloseDelayReportModal = () => {
        setSelectedFlightId(null);
        setShowDelayReportModal(false);
    }

    const table = useMaterialReactTable({
        columns,
        data,
        enableFilters: false,
        enableRowSelection: false,
        enableExpandAll: false,
        getRowId: (row) => row.id,
        initialState: { showColumnFilters: true },
        manualFiltering: true,
        manualPagination: true,
        manualSorting: true,
        muiToolbarAlertBannerProps: isError
            ? {
                color: 'error',
                children: 'Error loading data',
            }
            : undefined,
        onColumnFiltersChange: setColumnFilters,
        onGlobalFilterChange: setGlobalFilter,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        rowCount,
        state: {
            columnFilters,
            globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            sorting,
        },

        muiTableHeadCellProps: {
            //simple styling with the `sx` prop, works just like a style prop in this example
            sx: {
                backgroundColor: 'rgb(113, 185, 172)',
                textAlign: 'right'
            },
        },
        muiTableBodyCellProps: ({ column }) => ({
            //conditionally style pinned columns
            sx: {
                textAlign: 'right',
            },
        }),
        muiTableBodyProps: {
            sx: {
                //stripe the rows, make odd rows a darker color
                '& tr:nth-of-type(odd) > td': {
                    backgroundColor: '#f5f5f5',
                },
            },
        },
        enableRowActions: true,
        positionActionsColumn: 'last',

        renderRowActions: ({ row }) => (
            <Box sx={{ display: "flex", gap: "12px" }} >
                { //(AccessControl.checkPermissions(userPermissions, ["AirLineSLA:CalculatePilgrimFlightDelayCompensation"])) && 
                    <div dir="rtl">

                        {row.original.data?.flightDateReal && <Tooltip title="  ثبت هزینه تاخیر پرواز" placement="top">
                            <IconButton style={{ margin: '1px', borderRadius: 0 }} onClick={() => {
                                GotoCompensation(row.original.data);
                            }}>
                                <BiTimer color='#4a148c' />
                            </IconButton>
                        </Tooltip>}


                    </div>
                }
                {
                    <div dir="rtl">

                        {row.original.data?.flightDateReal &&
                            <Tooltip title="دانلود فایل هزینه عودتی بلیط مسافرین" placement="top">
                                <IconButton disabled={loadingExport || isLoading} type="button" onClick={() => { handleExportDelayComp(row.original.data) }}>
                                    {(loadingExport || isLoading) && <CircularProgress color="inherit" size="20px" sx={{ mx: '0.5rem' }} />}
                                    <ImFileExcel color='#04636E' />
                                </IconButton>
                            </Tooltip>
                        }
                    </div>
                }
                {<div dir="rtl">

                    {row.original.data?.flightDateReal && <Tooltip title=" مشاهده گزارش هزینه تاخیر پرواز" placement="top">
                        <IconButton style={{ margin: '1px', borderRadius: 0 }} onClick={() => {
                            handleOpenDelayReportModal(row.original.data);
                        }}>
                            <FaRegFileAlt color='#4a148c' />
                        </IconButton>
                    </Tooltip>}


                </div>
                }

            </Box>
        ),
        displayColumnDefOptions: {
            'mrt-row-actions': {
                header: ' ', //change header text
            },
        },


    });

    const GetFlightype = () => {
        brokerGroupApi.GetFlightTypeDropDown()
            .then((res) => {
                const arr = helper.DictionayToList(res.data.data);
                setFlightType(arr.map((o) => {
                    return {
                        id: o.key,
                        label: o.value
                    };
                }));
            })
            .catch((error) => console.log(error));
    }

    useEffect(() => {
        GetFlightype();
        GetDelayList();
    }, [])

    useEffect(() => {
        GetDelayList();

    }, [
        columnFilters, //re-fetch when column filters change
        globalFilter, //re-fetch when global filter changes
        pagination.pageIndex, //re-fetch when page index changes
        pagination.pageSize, //re-fetch when page size changes
        sorting, //re-fetch when sorting changes

    ]);

    const getfilteritems = () => {

        let flightType = null;
        if (watch("flightTypeID")) {
            flightType = watch("flightTypeID");
            if ((parseInt(flightType) !== parseInt(EnumMapper.FlightType.Departure)) && (parseInt(flightType) !== parseInt(EnumMapper.FlightType.Return)))
                flightType = null;
        }
        const flightNo = watch("flightNo") ? watch("flightNo") : null

        let DateFromGregorian = null;
        if (watch("DateFrom")) {
            let fromDate = new DateObject({
                date: watch("DateFrom"),
                calendar: persian,
                locale: persian_fa
            });
            // fromDateFromGregorian = fromDate.convert(gregorian, gregorian_en).format("YYYY-MM-DD");
            var DateFromStr = fromDate.year + '/' + fromDate.month.number + '/' + fromDate.day;
            DateFromGregorian = moment.from(DateFromStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        }

        let DateToGregorian = null;
        if (watch("DateTo")) {
            let toDate = new DateObject({
                date: watch("DateTo"),
                calendar: persian,
                locale: persian_fa
            });


            // toDateFromGregorian = toDate.convert(gregorian, gregorian_en).format("YYYY-MM-DD");
            var toDateFromStr = toDate.year + '/' + toDate.month.number + '/' + toDate.day;
            DateToGregorian = moment.from(toDateFromStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        }

        const paginationData = {
            "flightType": parseInt(flightType),
            "flightNo": flightNo,
            "datefrom": DateFromGregorian,
            "dateto": DateToGregorian,
            "orderBy": sorting.length > 0 ? sorting[0].id : 'CreateOn',
            "orderDescending": sorting.length > 0 ? sorting[0].desc : true,
            "pageSize": pagination.pageSize,
            "pageNumber": pagination.pageIndex + 1,
        }
        return paginationData;
    }
    const GetDelayList = () => {
        const filterData = getfilteritems();
        setIsloading(true);
        brokerGroupApi.GetDelay(filterData).then((res) => {
            if (res.data.data.items) {
                setData(res.data.data.items);
                setRowCount(res.data.data.items.length);
            }
            else {
                setData([]);
                setRowCount(0);
            }
        })
            .catch((err) => {
                if (err.response?.data) {
                    setOpen({ IsEnable: true, Message: err.response.data.title, severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }
            })
            .finally(() => setIsloading(false));
    }
    const handleExportDelayComp = async (data) => {
        setLoadingExport(true);
        FlightCompensationApi.CalculatePilgrimFlightDelayCompensation(data.id)
            .then((data) => {
                if (data.data.data?.length > 0)
                    GetExportData(data.data.data);
                else {
                    setOpen({ IsEnable: true, Message: 'هزینه ای برای این پرواز محاسبه نشده است', severity: severitys.info });
                }
            })
            .catch((err) => {
                if (err.response?.data) {
                    setOpen({ IsEnable: true, Message: err.response.data.title, severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }
            }).finally(() => {
                setLoadingExport(false);
            });


    }
    //export to excel
    const workSheetName = 'Sheet1';
    const workbook = new Excel.Workbook();

    const GetExportData = (Data) => {
        var clmns = [];
        var filename = '';
        filename = 'گزارش مبالغ عودتی بلیط مسافرین '
        clmns = [
            { header: 'نام', key: 'name' },
            { header: 'نام خانوادگی', key: 'family' },
            { header: 'کد ملی', key: 'ssn' },
            { header: 'مبلغ عودتی بلیط', key: 'ticketPrice' },

        ]
        saveExcel(Data, clmns, filename);
    }
    const saveExcel = async (expData, columns, workBookName) => {
        try {
            const fileName = workBookName;

            // creating one worksheet in workbook
            const worksheet = workbook.addWorksheet(workSheetName);
            worksheet.views = [{ rightToLeft: true }];
            // add worksheet columns
            // each columns contains header and its mapping key from data
            worksheet.columns = columns;

            // updated the font for first row.
            worksheet.getRow(1).font = { bold: true };

            // loop through all of the columns and set the alignment with width.
            worksheet.columns?.forEach(column => {
                if (column.name === '')
                    column.width = column.header.length + 5;
                column.alignment = { horizontal: 'center' };
            });

            // loop through data and add each one to worksheet
            expData?.forEach(singleData => {
                worksheet.addRow(singleData);
            });

            // loop through all of the rows and set the outline style.
            worksheet.eachRow({ includeEmpty: false }, row => {
                // store each cell to currentCell
                const currentCell = row._cells;

                // loop through currentCell to apply border only for the non-empty cell of excel
                currentCell.forEach(singleCell => {
                    // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
                    const cellAddress = singleCell._address;
                    singleCell.numFmt = '@'
                    // apply border
                    // worksheet.getCell(cellAddress).border = {
                    //   top: { style: 'thin' },
                    //   left: { style: 'thin' },
                    //   bottom: { style: 'thin' },
                    //   right: { style: 'thin' }
                    // };
                });
            });

            // write the content using writeBuffer
            const buf = await workbook.xlsx.writeBuffer();

            // download the processed file
            saveAs(new Blob([buf]), `${fileName}.xlsx`);
        } catch (error) {
            console.error('<<<ERRROR>>>', error);
            console.error('Something Went Wrong', error.message);
        } finally {
            // removing worksheet's instance to create new one
            workbook.removeWorksheet(workSheetName);
        }
    };


    return (
        <ThemeProvider theme={customtheme(customization)}>

            <RtlProvider>
                  <CustomTitle title={'لیست  پرواز تاخیری '}  />
                <form onSubmit={handleSubmit(GetDelayList)} >
                    <Grid container spacing={1}>

                        <Grid item md={1.5} xs={3.5}>

                            <RHFAutocomplete
                                control={control}
                                options={flightType}
                                name="flightTypeID"
                                placeholder="نوع پرواز"
                                style={{
                                    border: "none",
                                    padding: 0
                                }}
                            />
                        </Grid>
                        <Grid item md={1.5} xs={3.5} >
                            <TextField
                                label="شماره پرواز"
                                {...register("flightNo")}
                            />
                        </Grid>

                        <Grid item size={2}>

                            <Controller
                                control={control}
                                name="DateFrom"
                                rules={{ required: true }}
                                render={({
                                    field: { onChange, name, value },
                                    fieldState: { invalid, isDirty },
                                }) => (
                                    <>
                                        <DatePicker
                                            value={value || ""}
                                            onChange={(date) => {
                                                onChange(date?.isValid ? date : "");
                                            }}
                                            format={"YYYY/MM/DD"}
                                            calendar={persian}
                                            locale={persian_fa}
                                            calendarPosition="bottom-right"
                                            render={<CustomDateInput label={" از تاریخ "} />}
                                        />
                                    </>
                                )}
                            />
                        </Grid>
                        <Grid item size={2}>

                            <Controller
                                control={control}
                                name="DateTo"
                                rules={{ required: true }}
                                render={({
                                    field: { onChange, name, value },
                                    fieldState: { invalid, isDirty },
                                }) => (
                                    <>
                                        <DatePicker
                                            value={value || ""}
                                            onChange={(date) => {
                                                onChange(date?.isValid ? date : "");
                                            }}
                                            format={"YYYY/MM/DD"}
                                            calendar={persian}
                                            locale={persian_fa}
                                            calendarPosition="bottom-right"
                                            render={<CustomDateInput label={"تا تاریخ "} />}
                                        />
                                    </>
                                )}
                            />
                        </Grid>

                        <Grid item size={4} spacing={1} sx={{ marginTop: 0.5, marginBottom: 0.5 }}>
                            <Button type="submit" variant="contained" color="primary"  >
                                {isLoading && <CircularProgress color="inherit" size="20px" sx={{ mx: '0.5rem' }} />}
                                جستجو
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </RtlProvider>
            <div dir="rtl">

                <Typography ><Box sx={{ textAlign: 'left', dir: 'rtl' }}> {'تعداد نتایج' + ' : ' + rowCount} </Box></Typography>

                <Box sx={{ marginTop: 1 }} >
                    <MaterialReactTable table={table} />
                </Box>
            </div>
            <Modal
                alignItems='center'
                open={showDelayReportModal}
                onClose={handleCloseDelayReportModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box>
                    <FlightDelayCompensation flightId={selectedFlightId} />
                </Box>
            </Modal>

        </ThemeProvider>
    )
}
export default DelayList